(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('components/slide-answers.html', '<div class=\"question_options options\" ng-class=\"{\'is-counted\': (stage == \'counted\'), \'is-reveal-answers\' : checkCount >= 1}\">\n	<button class=\"option option--{{ settings.index_to_color[$index] }}\"\n    ng-repeat=\"answer in slide.answers\"\n    ng-click=\"selectAnswer($index)\"\n    ng-class=\"{\'is-correct\' : (feedback.correct === $index), \'is-selected\': $index === selectedAnswer}\"\n    >\n	    \n			<div class=\"option_content\">\n				<span class=\"circle\"><b>{{ settings.answers[$index] }}</b><i>{{ formatPercentage(percentages[$index]) }}</i></span>\n				<span class=\"text\">{{ answer }}</span>\n			</div>\n		</div>\n	</button>\n</div>\n');
    }]);
})();